import { bl_cms_facilities_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class CmsFacilityContainerModel extends BaseContainerModel {
    bl_cms_facilities_hdr: bl_cms_facilities_hdr_RowClass = new bl_cms_facilities_hdr_RowClass();
}